export default __webpack_public_path__ + "01e914b.png";